import React from "react";
import S3Image from "@/images/s3bucket-icon.png";
import { ISVG } from "./interface";

const SVG: React.FC<ISVG> = ({
  style = {},
  width = 16,
  height = 16,
  className = "",
  viewBox = "0 0 16 16",
}) => (
  <svg
    width={width}
    style={style}
    height={height}
    viewBox={viewBox}
    fillRule="evenodd"
    stroke="var(--tlx-color-grey-600)"
    strokeLinecap="round"
    strokeLinejoin="round"
    xmlns="http://www.w3.org/2000/svg"
    className={`svg-icon ${className || ""}`}
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <image href={S3Image} height={height} width={width} />
  </svg>
);

export default SVG;
